/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-props-no-spreading */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import PropTypes from "prop-types";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
// @mui material components
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import moment from "moment";
// Data
import solicitudTableData from "./data/solicitudTableData";
import {
  getObtenerSolicitud,
  MarcarSolicitudLeido,
  getCatalogosT,
  getInformacionInicialDocumentos,
  ActualizarSolicitud,
} from "store/solicitudes/solicitudesActions";

import InfoIcon from "@mui/icons-material/Info";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import ArchiveIcon from "@mui/icons-material/Archive";
import MedicalInformationIcon from "@mui/icons-material/MedicalInformation";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import EventIcon from "@mui/icons-material/Event";
import GroupsIcon from "@mui/icons-material/Groups";
import ApartmentIcon from "@mui/icons-material/Apartment";
import PhotoCameraBackIcon from "@mui/icons-material/PhotoCameraBack";

import ModalContent from "../../components/ModalContent";
import FormUsuario from "./formNuevaSolicitud";
import VerticalTabs from "./tabs";
import FormBusqueda from "./forms/formBusqueda";
import Loading from "../../components/loading";
import { Divider, Grid, Paper } from "@mui/material";
import brandDark from "assets/images/LogoESF.png";
import Header from "./Header";
import InformacionGeneral from "./forms/informacionGeneral";
import InformacionGeneralMenor from "./forms/informacionMenor";
import AntecedentesHeredoFamiliares from "./forms/antecedentesHeredoFamiliares";
import AntecedentesPrenatales from "./forms/antecedentesPrenatales";
import AntecedentesPerinatales from "./forms/antecedentesPerinatales";
import AntecedentesPatologicos from "./forms/antecedentesPersonlesNoPatologicos";
import EvaluacionAuditiva from "./forms/evalucionAuditivaLinguistica";
import DesarrolloMotor from "./forms/desarrolloMotor";
import DatosAdicionales1 from "./forms/datosAdicionales1";
import InformacionAdicional2 from "./forms/informacionAdicional2";
import DocumentacionAdministrativa from "./forms/documentacionAdministrativa";
import DocumentacionClinica from "./forms/documentacionClinica";
import DocumentacionAdministrativaEdit from "./forms/documentacionAdinistrativaEdit";
import DocumentacionClinicaEdit from "./forms/documentacionClinicaEdit";
import EstudiosSocioeconomicoEdit from "./forms/estudioSocioeconomicoEdit";
import DocumentosReunionNacional from "./forms/documentosReunionNacional";
import DocumentosReunionBoston from "./forms/documentosReunionBoston";
import { resetDocumentacionSolicitud } from "store/solicitudes/solicitudesSlice";
import Citas from "./citas";
import Galeria from "./galeria/galeria";
import { store } from "store/store";
import _ from "lodash";

function DetallesSolicitud() {
  const { state } = useLocation();
  const {
    detalleSolicitud,
    isloadingdetalleSolicitud,
    docsReunionBoston,
    docsReunionNacional,
    documentacionClinica,
    estudiosSE,
  } = useSelector((state) => state.solicitud);
  const [tabValue, setTabValue] = useState(0);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetDocumentacionSolicitud());

    MarcarSolicitudLeido(dispatch, state?.id);
    getObtenerSolicitud(dispatch, state?.id);
    getCatalogosT(dispatch);
    getInformacionInicialDocumentos(dispatch, state?.id);
  }, [state?.id, dispatch]);

  const handleSetTabValue = (event, newValue) => setTabValue(newValue);
  const docClinicaMostrar = [
    {
      label: "Cartilla de Vacunación",
      campo: "docCartillaVacunaValidada",
      campoBD: "archivoCartillaVacunacion",
      archivo: detalleSolicitud.archivoCartillaVacunacion,
      validado: detalleSolicitud.docCartillaVacunaValidada,
      validadopor: detalleSolicitud.docCartillaVacunaValidadaPorName,
      loading: false,
    },
    {
      label: "Cuestionario de Expectativas",
      campo: "docCuestionarioValidado",
      campoBD: "archivoCuestionarioExpectativas",
      archivo: detalleSolicitud.archivoCuestionarioExpectativas,
      validado: detalleSolicitud.docCuestionarioValidado,
      validadopor: detalleSolicitud.docCuestionarioValidadoPorName,
      loading: false,
    },
  ];
  const documentacionAdministrativa = [
    {
      label: "Carta de Inicio",
      campo: "docCartaInicioValidada",
      campoBD: "archivoCartaInicio",
      archivo: detalleSolicitud.archivoCartaInicio,
      validado: detalleSolicitud.docCartaInicioValidada,
      validadopor: detalleSolicitud.docCartaInicioValidadaPorName,
      loading: false,
    },
    {
      label: "Cuestionario de Expectativas",
      campo: "docCuestionarioValidado",
      campoBD: "archivoCuestionarioExpectativas",
      archivo: detalleSolicitud.archivoCuestionarioExpectativas,
      validado: detalleSolicitud.docCuestionarioValidado,
      validadopor: detalleSolicitud.docCuestionarioValidadoPorName,
      loading: false,
    },
    {
      label: "Acta de nacimiento del menor",
      campo: "docActaNacimValidada",
      campoBD: "archivoActaNacimiento",
      archivo: detalleSolicitud.archivoActaNacimiento,
      validado: detalleSolicitud.docActaNacimValidada,
      validadopor: detalleSolicitud.docActaNacimValidadaPorName,
      loading: false,
    },
    {
      label: "CURP del Menor",
      campo: "docCurpMenorValidada",
      campoBD: "archivoCurpMenor",
      archivo: detalleSolicitud.archivoCurpMenor,
      validado: detalleSolicitud.docCurpMenorValidada,
      validadopor: detalleSolicitud.docCurpMenorValidadaPorName,
      loading: false,
    },
    {
      label: "CURP del Padre",
      campo: "docCurpPadreValidada",
      campoBD: "archivoCurpPadre",
      archivo: detalleSolicitud.archivoCurpPadre,
      validado: detalleSolicitud.docCurpPadreValidada,
      validadopor: detalleSolicitud.docCurpPadreValidadaPorName,
      loading: false,
    },
    {
      label: "CURP de la Madre",
      campo: "docCurpMadreValidada",
      campoBD: "archivoCurpMadre",
      archivo: detalleSolicitud.archivoCurpMadre,
      validado: detalleSolicitud.docCurpMadreValidada,
      validadopor: detalleSolicitud.docCurpMadreValidadaPorName,
      loading: false,
    },
    {
      label: "Identificación oficial del Padre",
      campo: "docIdentificaPadreValidada",
      campoBD: "archivoIdentificacionPadre",
      archivo: detalleSolicitud.archivoIdentificacionPadre,
      validado: detalleSolicitud.docIdentificaPadreValidada,
      validadopor: detalleSolicitud.docIdentificaPadreValidadaPorName,
      loading: false,
    },
    {
      label: "Identificación oficial de la Madre",
      campo: "docIdentificaMadreValidada",
      campoBD: "archivoIdentificacionMadre",
      archivo: detalleSolicitud.archivoIdentificacionMadre,
      validado: detalleSolicitud.docIdentificaMadreValidada,
      validadopor: detalleSolicitud.docIdentificaMadreValidadaPorName,
      loading: false,
    },
    {
      label: "Cartilla de Vacunación",
      campo: "docCartillaVacunaValidada",
      campoBD: "archivoCartillaVacunacion",
      archivo: detalleSolicitud.archivoCartillaVacunacion,
      validado: detalleSolicitud.docCartillaVacunaValidada,
      validadopor: detalleSolicitud.docCartillaVacunaValidadaPorName,
      loading: false,
    },
    {
      label: "Comprobante de Domicilio",
      campo: "docComprobanteDomValidada",
      campoBD: "archivoComprobanteDomicilio",
      archivo: detalleSolicitud.archivoComprobanteDomicilio,
      validado: detalleSolicitud.docComprobanteDomValidada,
      validadopor: detalleSolicitud.docComprobanteDomValidadaPorName,
      loading: false,
    },
    {
      label: "Carta de Aceptación",
      campo: "docCartaAceptacionValidada",
      campoBD: "archivoCartaAceptacion",
      archivo: detalleSolicitud.archivoCartaAceptacion,
      validado: detalleSolicitud.docCartaAceptacionValidada,
      validadopor: detalleSolicitud.docCartaAceptacionValidadaPorName,
      loading: false,
    },
    {
      label: "Carta de Autorización Uso de Imagen Papá",
      campo: "docCartaAutorizacionImagenPapaValidada",
      campoBD: "archivoCartaImagenPapa",
      archivo: detalleSolicitud.archivoCartaImagenPapa,
      validado: detalleSolicitud.docCartaAutorizacionImagenPapaValidada,
      validadopor: detalleSolicitud.docCartaAutorizacionImagenPapaValidadaPorName,
      loading: false,
    },
    {
      label: "Carta de Autorización Uso de Imagen Mamá",
      campo: "docCartaAutorizacionImagenMamaValidada",
      campoBD: "archivoCartaImagenMama",
      archivo: detalleSolicitud.archivoCartaImagenMama,
      validado: detalleSolicitud.docCartaAutorizacionImagenMamaValidada,
      validadopor: detalleSolicitud.docCartaAutorizacionImagenMamaValidadaPorName,
      loading: false,
    },
    {
      label: "Carta de Autorización Uso de Imagen Candidato",
      campo: "docCartaAutorizacionImagenCandidatoValidada",
      campoBD: "archivoCartaImagenCandidato",
      archivo: detalleSolicitud.archivoCartaImagenCandidato,
      validado: detalleSolicitud.docCartaAutorizacionImagenCandidatoValidada,
      validadopor: detalleSolicitud.docCartaAutorizacionImagenCandidatoValidadaPorName,
      loading: false,
    },
    {
      label: "Carta transferencia de Datos",
      campo: "docCartaTransferenciaValidado",
      campoBD: "archivoCartaTransferenciaDatos",
      archivo: detalleSolicitud.archivoCartaTransferenciaDatos,
      validado: detalleSolicitud.docCartaTransferenciaValidado,
      validadopor: detalleSolicitud.validaTransferenciaDatos,
      loading: false,
    },
  ];

  //Editar datos
  const refInformacionGeneral = useRef();
  const refInformacionGeneralMenor = useRef();
  const refAntecedentesHeredo = useRef();
  const refAntecedentesPersonales = useRef();
  const refAntecedentesPrenatales = useRef();
  const refAntecedentesPerinatales = useRef();
  const refEvalaucionAuditiva = useRef();
  const refDesarrolloMotor = useRef();
  const refInfoAdicional = useRef();
  const refInfoAdicional2 = useRef();

  const [desactivar, setDesactivar] = useState(true);
  const [desactivar2, setDesactivar2] = useState(true);

  const [btnEditar, setBtnEditar] = useState(false);
  const [btnGuardar, setBtnGuardar] = useState(true);
  const [btnCancelar, setBtnCancelar] = useState(true);
  const [btnEditar2, setBtnEditar2] = useState(false);
  const [btnGuardar2, setBtnGuardar2] = useState(true);
  const [btnCancelar2, setBtnCancelar2] = useState(true);

  const handleGuardarNuevosDatos = async () => {
    const datos1 = await refInformacionGeneral.current?.ejecutarNext();
    if (!datos1) return;

    const datos2 = refInformacionGeneralMenor.current?.ejecutarNext();
    if (!datos2) return;

    const datos3 = refInfoAdicional2.current?.ejecutarNext();
    if (!datos3) return;

    const datosCompletos = {
      ...datos1,
      ...datos2,
      ...datos3,
    };

    setearDatosInfoGeneral(datosCompletos);
  };

  const handleGuardarNuevosDatos2 = () => {
    const datos1 = refAntecedentesHeredo.current?.ejecutarNext();
    if (!datos1) return;

    const datos2 = refAntecedentesPersonales.current?.ejecutarNext();
    if (!datos2) return;

    const datos3 = refAntecedentesPrenatales.current?.ejecutarNext();
    if (!datos3) return;

    const datos4 = refAntecedentesPerinatales.current?.ejecutarNext();
    if (!datos4) return;

    const datos5 = refEvalaucionAuditiva.current?.ejecutarNext();
    if (!datos5) return;

    const datos6 = refDesarrolloMotor.current?.ejecutarNext();
    if (!datos6) return;

    const datos7 = refInfoAdicional.current?.ejecutarNext();
    if (!datos7) return;

    const datosCompletos = {
      ...datos1,
      ...datos2,
      ...datos3,
      ...datos4,
      ...datos5,
      ...datos6,
      ...datos7,
    };

    setearDatosAntecedentes(datosCompletos);
  };

  const setearDatosAntecedentes = async (nuevosDatosAntecedentes) => {
    let dataInfoGeneral = {
      idSolicitud: detalleSolicitud?.idSolicitud,
      aMaternoCandidato: detalleSolicitud?.aMaternoCandidato,
      aMaternoCuidador: detalleSolicitud?.aMaternoCuidador,
      aMaternoLlena: detalleSolicitud?.aMaternoLlena,
      aMaternoMadre: detalleSolicitud?.aMaternoMadre,
      aMaternoPadre: detalleSolicitud?.aMaternoPadre,
      aPaternoCandidato: detalleSolicitud?.aPaternoCandidato,
      aPaternoCuidador: detalleSolicitud?.aPaternoCuidador,
      aPaternoLlena: detalleSolicitud?.aPaternoLlena,
      aPaternoMadre: detalleSolicitud?.aPaternoMadre,
      aPaternoPadre: detalleSolicitud?.aPaternoPadre,
      celularContacto: detalleSolicitud?.celularContacto,
      celularPediatra: detalleSolicitud?.celularPediatra,
      comoSeEnteroEspecif: detalleSolicitud?.comoSeEnteroEspecif,
      correoContacto: detalleSolicitud?.correoContacto,
      direccionCandidato: detalleSolicitud?.direccionCandidato,
      direccionPediatra: detalleSolicitud?.direccionPediatra,
      especifiqueParentescoCuidador: detalleSolicitud?.especifiqueParentescoCuidador,
      especifiqueParentescoLlena: detalleSolicitud?.especifiqueParentescoLlena,
      fechaAplicacion: detalleSolicitud?.fechaAplicacion,
      fechaNacimiento: detalleSolicitud?.fechaNacimiento,
      idComoSeEntero: detalleSolicitud?.idComoSeEntero,
      idEntidad: detalleSolicitud?.idEntidad,
      idMunicipio: detalleSolicitud?.idMunicipio,
      idParentescoCandidato: detalleSolicitud?.idParentescoCandidato,
      idParentescoCuidador: detalleSolicitud?.idParentescoCuidador,
      idServicioMedico: detalleSolicitud?.idServicioMedico,
      idSexo: detalleSolicitud?.idSexo,
      infoAdicional: detalleSolicitud?.infoAdicional,
      lugarNacimiento: detalleSolicitud?.lugarNacimiento,
      nacionalidad: detalleSolicitud?.nacionalidad,
      nombreCandidato: detalleSolicitud?.nombreCandidato,
      nombreCuidador: detalleSolicitud?.nombreCuidador,
      nombreLlena: detalleSolicitud?.nombreLlena,
      nombreMadre: detalleSolicitud?.nombreMadre,
      nombrePadre: detalleSolicitud?.nombrePadre,
      nombrePediatra: detalleSolicitud?.nombrePediatra,
      ocupacionMadre: detalleSolicitud?.ocupacionMadre,
      ocupacionPadre: detalleSolicitud?.ocupacionPadre,
      otroServicioMedico: detalleSolicitud?.otroServicioMedico,
      otroTelefonoContacto: detalleSolicitud?.otroTelefonoContacto,
      textcalculomesesanio: detalleSolicitud?.textcalculomesesanio,
    };
    const exito = await dispatch(
      ActualizarSolicitud({ ...dataInfoGeneral, ...nuevosDatosAntecedentes })
    );
    if (exito) {
      setDesactivar2(true);
      setBtnEditar2(false);
      setBtnGuardar2(true);
      setBtnCancelar2(true);
    }
  };

  const setearDatosInfoGeneral = async (nuevosDatosInformacion) => {
    let dataAntecedentes = {
      idSolicitud: detalleSolicitud?.idSolicitud,
      alergiasCandidato: detalleSolicitud?.alergiasCandidato,
      apgaR1: detalleSolicitud?.apgaR1,
      apgaR2: detalleSolicitud?.apgaR2,
      aplicadoOtroPrograma: detalleSolicitud?.aplicadoOtroPrograma,
      aplicadoOtroProgramaCual: detalleSolicitud?.aplicadoOtroProgramaCual,
      asisteGuarderia: detalleSolicitud?.asisteGuarderia,
      audiologoAjuste: detalleSolicitud?.audiologoAjuste,
      audiologoEvalua: detalleSolicitud?.audiologoEvalua,
      causaPerdidaAuditiva: detalleSolicitud?.causaPerdidaAuditiva,
      computadora: detalleSolicitud?.computadora,
      computadoraCual: detalleSolicitud?.computadoraCual,
      contactoVisual: detalleSolicitud?.contactoVisual,
      crisisConvulsivas: detalleSolicitud?.crisisConvulsivas,
      cualMalformacion: detalleSolicitud?.cualMalformacion,
      cualRetraso: detalleSolicitud?.cualRetraso,
      cualesMedicamentos: detalleSolicitud?.cualesMedicamentos,
      dadoAltaConMadre: detalleSolicitud?.dadoAltaConMadre,
      dedoApuntar: detalleSolicitud?.dedoApuntar,
      diagnosticoAudicion: detalleSolicitud?.diagnosticoAudicion,
      dietaAlimentacion: detalleSolicitud?.dietaAlimentacion,
      edadBalbuceo: detalleSolicitud?.edadBalbuceo,
      edadBano: detalleSolicitud?.edadBano,
      edadCamino: detalleSolicitud?.edadCamino,
      edadComio: detalleSolicitud?.edadComio,
      edadGateo: detalleSolicitud?.edadGateo,
      edadGestacional: detalleSolicitud?.edadGestacional,
      edadGiros: detalleSolicitud?.edadGiros,
      edadObjetosSimples: detalleSolicitud?.edadObjetosSimples,
      edadParo: detalleSolicitud?.edadParo,
      edadPrimerasPalabras: detalleSolicitud?.edadPrimerasPalabras,
      edadSento: detalleSolicitud?.edadSento,
      edadSonrisaSocial: detalleSolicitud?.edadSonrisaSocial,
      edadSostuvoCabeza: detalleSolicitud?.edadSostuvoCabeza,
      enfCardioFamiliar: detalleSolicitud?.enfCardioFamiliar,
      enfCardioHermanos: detalleSolicitud?.enfCardioHermanos,
      enfCardioMadre: detalleSolicitud?.enfCardioMadre,
      enfCardioPadre: detalleSolicitud?.enfCardioPadre,
      enfMetabolicasFamiliar: detalleSolicitud?.enfMetabolicasFamiliar,
      enfMetabolicasHermanos: detalleSolicitud?.enfMetabolicasHermanos,
      enfMetabolicasMadre: detalleSolicitud?.enfMetabolicasMadre,
      enfMetabolicasPadre: detalleSolicitud?.enfMetabolicasPadre,
      enfNeoplasicasFamiliar: detalleSolicitud?.enfNeoplasicasFamiliar,
      enfNeoplasicasHermanos: detalleSolicitud?.enfNeoplasicasHermanos,
      enfNeoplasicasMadre: detalleSolicitud?.enfNeoplasicasMadre,
      enfNeoplasicasPadre: detalleSolicitud?.enfNeoplasicasPadre,
      enfNingunaHermanos: detalleSolicitud?.enfNingunaHermanos,
      enfNingunaMadre: detalleSolicitud?.enfNingunaMadre,
      enfNingunaPadre: detalleSolicitud?.enfNingunaPadre,
      enfPsiqFamiliar: detalleSolicitud?.enfPsiqFamiliar,
      enfPsiqHermanos: detalleSolicitud?.enfPsiqHermanos,
      enfPsiqMadre: detalleSolicitud?.enfPsiqMadre,
      enfPsiqPadre: detalleSolicitud?.enfPsiqPadre,
      escuchaActualmente: detalleSolicitud?.escuchaActualmente,
      especifiqueCirugias: detalleSolicitud?.especifiqueCirugias,
      especifiqueGolpes: detalleSolicitud?.especifiqueGolpes,
      especifiqueInfeccion: detalleSolicitud?.especifiqueInfeccion,
      especifiqueInfeccionCMV: detalleSolicitud?.especifiqueInfeccionCMV,
      especifiqueInfeccionesOido: detalleSolicitud?.especifiqueInfeccionesOido,
      especifiqueProbAlimenta: detalleSolicitud?.especifiqueProbAlimenta,
      estudiosAudicion: detalleSolicitud?.estudiosAudicion,
      evalOtroEspecialista: detalleSolicitud?.evalOtroEspecialista,
      evalOtroEspecialistaCual: detalleSolicitud?.evalOtroEspecialistaCual,
      evaluadoAudiologia: detalleSolicitud?.evaluadoAudiologia,
      evaluadoOdontologia: detalleSolicitud?.evaluadoOdontologia,
      evaluadoOdontologiaDr: detalleSolicitud?.evaluadoOdontologiaDr,
      evaluadoOtorrino: detalleSolicitud?.evaluadoOtorrino,
      evaluadoTerapiaLenguaje: detalleSolicitud?.evaluadoTerapiaLenguaje,
      fechaAdaptacionAuxiliaresAud: detalleSolicitud?.fechaAdaptacionAuxiliaresAud,
      fechaAjusteAuxAuditivos: detalleSolicitud?.fechaAjusteAuxAuditivos,
      fechaPerdidaAuditiva: detalleSolicitud?.fechaPerdidaAuditiva,
      fileEstudioTorch: detalleSolicitud?.fileEstudioTorch,
      fumanEnCasa: detalleSolicitud?.fumanEnCasa,
      golpesCabeza: detalleSolicitud?.golpesCabeza,
      gradoHipoacusia: detalleSolicitud?.gradoHipoacusia,
      haAjustadoAuxAuditivos: detalleSolicitud?.haAjustadoAuxAuditivos,
      haRecibidoTerapiaAudVerbal: detalleSolicitud?.haRecibidoTerapiaAudVerbal,
      hospitalizado: detalleSolicitud?.hospitalizado,
      idComunicacionBuscada: detalleSolicitud?.idComunicacionBuscada,
      idTipoParto: detalleSolicitud?.idTipoParto,
      idTipoPerdidaAuditiva: detalleSolicitud?.idTipoPerdidaAuditiva,
      idTipoSangre: detalleSolicitud?.idTipoSangre,
      idTipoSangreRh: detalleSolicitud?.idTipoSangreRh,
      idiomaEnCasa: detalleSolicitud?.idiomaEnCasa,
      idiomaMadre: detalleSolicitud?.idiomaMadre,
      idiomaPadre: detalleSolicitud?.idiomaPadre,
      infeccionCMV: detalleSolicitud?.infeccionCMV,
      infeccionEmbarazo: detalleSolicitud?.infeccionEmbarazo,
      infeccionesGarganta: detalleSolicitud?.infeccionesGarganta,
      infeccionesOido: detalleSolicitud?.infeccionesOido,
      lenguajeActual: detalleSolicitud?.lenguajeActual,
      malformacion: detalleSolicitud?.malformacion,
      marcaAuxAuditivos: detalleSolicitud?.marcaAuxAuditivos,
      medicamentosActuales: detalleSolicitud?.medicamentosActuales,
      motivoTerapiaIntensiva: detalleSolicitud?.motivoTerapiaIntensiva,
      nombreFamiliarHeredo: detalleSolicitud?.nombreFamiliarHeredo,
      otorrinoEvalua: detalleSolicitud?.otorrinoEvalua,
      otrasHeredoFamiliar: detalleSolicitud?.otrasHeredoFamiliar,
      otrasHeredoHermanos: detalleSolicitud?.otrasHeredoHermanos,
      otrasHeredoMadre: detalleSolicitud?.otrasHeredoMadre,
      otrasHeredoPadre: detalleSolicitud?.otrasHeredoPadre,
      padecioIctericia: detalleSolicitud?.padecioIctericia,
      pesoNacimiento: detalleSolicitud?.pesoNacimiento,
      plataformaVideo: detalleSolicitud?.plataformaVideo,
      plataformaVideoCual: detalleSolicitud?.plataformaVideoCual,
      probAudicionFamiliar: detalleSolicitud?.probAudicionFamiliar,
      probAudicionHermanos: detalleSolicitud?.probAudicionHermanos,
      probAudicionMadre: detalleSolicitud?.probAudicionMadre,
      probAudicionPadre: detalleSolicitud?.probAudicionPadre,
      probRenalesFamiliar: detalleSolicitud?.probRenalesFamiliar,
      probRenalesHermanos: detalleSolicitud?.probRenalesHermanos,
      probRenalesMadre: detalleSolicitud?.probRenalesMadre,
      probRenalesPadre: detalleSolicitud?.probRenalesPadre,
      problemaAlimentacion: detalleSolicitud?.problemaAlimentacion,
      profQueDiagnostico: detalleSolicitud?.profQueDiagnostico,
      progresosObtenidos: detalleSolicitud?.progresosObtenidos,
      quienFuma: detalleSolicitud?.quienFuma,
      rechazadoPrograma: detalleSolicitud?.rechazadoPrograma,
      rechazadoProgramaCual: detalleSolicitud?.rechazadoProgramaCual,
      resEstudioTorch: detalleSolicitud?.resEstudioTorch,
      resTamizNeoAuditivo: detalleSolicitud?.resTamizNeoAuditivo,
      resTamizNeoCardiaco: detalleSolicitud?.resTamizNeoCardiaco,
      resTamizNeoMetabolico: detalleSolicitud?.resTamizNeoMetabolico,
      resTamizNeoVisual: detalleSolicitud?.resTamizNeoVisual,
      ronca: detalleSolicitud?.ronca,
      servicioInternet: detalleSolicitud?.servicioInternet,
      servicioInternetCual: detalleSolicitud?.servicioInternetCual,
      tallaNacimiento: detalleSolicitud?.tallaNacimiento,
      tamizNeoAuditivo: detalleSolicitud?.tamizNeoAuditivo,
      tamizNeoCardiaco: detalleSolicitud?.tamizNeoCardiaco,
      tamizNeoMetabolico: detalleSolicitud?.tamizNeoMetabolico,
      tamizNeoVisual: detalleSolicitud?.tamizNeoVisual,
      terapeutaEvalua: detalleSolicitud?.terapeutaEvalua,
      terapiaAudVerbalQuien: detalleSolicitud?.terapiaAudVerbalQuien,
      terapiaIntensiva: detalleSolicitud?.terapiaIntensiva,
      tiempoInicioPerdidaAud: detalleSolicitud?.tiempoInicioPerdidaAud,
      tieneCirugias: detalleSolicitud?.tieneCirugias,
      tieneEstudiosAudicion: detalleSolicitud?.tieneEstudiosAudicion,
      tieneEvaluacionVista: detalleSolicitud?.tieneEvaluacionVista,
      tieneRetrasoDesarrollo: detalleSolicitud?.tieneRetrasoDesarrollo,
      tomadoMedicamentos: detalleSolicitud?.tomadoMedicamentos,
      tuvoMeningitis: detalleSolicitud?.tuvoMeningitis,
      utilizaAuxAuditivos: detalleSolicitud?.utilizaAuxAuditivos,
      vacunacionCompleta: detalleSolicitud?.vacunacionCompleta,
      ventilacionMecanica: detalleSolicitud?.ventilacionMecanica,
    };

    const exito = await dispatch(
      ActualizarSolicitud({ ...dataAntecedentes, ...nuevosDatosInformacion })
    );
    if (exito) {
      setDesactivar(true);
      setBtnEditar(false);
      setBtnGuardar(true);
      setBtnCancelar(true);
    }
  };

  const usuarioPermisos = store.getState().login?.usuario?.permisos;
  const informacionGeneral = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (detalleSolicitud?.esExpediente == 1 ? 54 : 7)
  );
  const antecedentes = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (detalleSolicitud?.esExpediente == 1 ? 55 : 8)
  );
  const docadministrativa = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (detalleSolicitud?.esExpediente == 1 ? 56 : 9)
  );
  const docclinica = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (detalleSolicitud?.esExpediente == 1 ? 57 : 10)
  );
  const estuciosocioeconomico = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (detalleSolicitud?.esExpediente == 1 ? 58 : 11)
  );
  const citas = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (detalleSolicitud?.esExpediente == 1 ? 59 : 12)
  );
  const reuniones = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (detalleSolicitud?.esExpediente == 1 ? 60 : 13)
  );
  const galeria = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (detalleSolicitud?.esExpediente == 1 ? 86 : 45)
  );
  const editarInformacion = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (detalleSolicitud?.esExpediente == 1 ? 61 : 14)
  );

  // Arreglo de secciones visibles basado en permisos
  const seccionesVisibles = [
    informacionGeneral.length === 0
      ? null
      : {
          label: "Información General",
          icon: <InfoIcon />,
          panel: (
            <>
              {detalleSolicitud?.esExpediente == 0 &&
                (editarInformacion.length == 0 ? null : (
                  <MDBox textAlign="right">
                    <Button
                      variant="contained"
                      startIcon={<Icon>edit</Icon>}
                      onClick={() => {
                        setDesactivar(false);
                        setBtnEditar(true);
                        setBtnGuardar(false);
                        setBtnCancelar(false);
                      }}
                      size="small"
                      color="primary"
                      disabled={btnEditar}
                    >
                      Editar
                    </Button>
                    <Button
                      variant="contained"
                      startIcon={<Icon>close</Icon>}
                      onClick={() => {
                        setDesactivar(true);
                        setBtnEditar(false);
                        setBtnGuardar(true);
                        setBtnCancelar(true);
                      }}
                      size="small"
                      color="primary"
                      disabled={btnCancelar}
                    >
                      Cancelar
                    </Button>
                    <Button
                      variant="contained"
                      startIcon={<Icon>save</Icon>}
                      onClick={() => {
                        handleGuardarNuevosDatos();
                      }}
                      size="small"
                      color="primary"
                      disabled={btnGuardar}
                    >
                      Guardar
                    </Button>
                  </MDBox>
                ))}
              <MDBox>
                <MDTypography
                  component="a"
                  href="#"
                  variant="caption"
                  color="primary"
                  fontWeight="medium"
                  paddingRight={1}
                >
                  Informacion General
                </MDTypography>
              </MDBox>
              <InformacionGeneral
                ref={refInformacionGeneral}
                Back={() => {}}
                Next={(data) => {}}
                desactivar={desactivar}
                IntentoSolicitud={(info) => {}}
                vista={"visualizar"}
                props={detalleSolicitud}
              />
              <Divider />
              <MDBox>
                <MDTypography
                  component="a"
                  href="#"
                  variant="caption"
                  color="primary"
                  fontWeight="medium"
                  paddingRight={1}
                >
                  Informacion General del Menor
                </MDTypography>
              </MDBox>
              <InformacionGeneralMenor
                ref={refInformacionGeneralMenor}
                Back={() => {}}
                Next={(data) => {}}
                desactivar={desactivar}
                IntentoSolicitud={(info) => {}}
                vista={"visualizar"}
                props={detalleSolicitud}
              />
              <InformacionAdicional2
                ref={refInfoAdicional2}
                Back={() => {}}
                Next={(data) => {}}
                desactivar={desactivar}
                IntentoSolicitud={(info) => {}}
                vista={"visualizar"}
                props={detalleSolicitud}
              />
            </>
          ),
        },
    antecedentes.length === 0
      ? null
      : {
          label: "Antecedentes",
          icon: <PendingActionsIcon />,
          panel: (
            <>
              {detalleSolicitud?.esExpediente == 0 &&
                (editarInformacion.length == 0 ? null : (
                  <MDBox textAlign="right">
                    <Button
                      variant="contained"
                      startIcon={<Icon>edit</Icon>}
                      onClick={() => {
                        setDesactivar2(false);
                        setBtnEditar2(true);
                        setBtnGuardar2(false);
                        setBtnCancelar2(false);
                      }}
                      size="small"
                      color="primary"
                      disabled={btnEditar2}
                    >
                      Editar
                    </Button>
                    <Button
                      variant="contained"
                      startIcon={<Icon>close</Icon>}
                      onClick={() => {
                        setDesactivar2(true);
                        setBtnEditar2(false);
                        setBtnGuardar2(true);
                        setBtnCancelar2(true);
                      }}
                      size="small"
                      color="primary"
                      disabled={btnCancelar2}
                    >
                      Cancelar
                    </Button>
                    <Button
                      variant="contained"
                      startIcon={<Icon>save</Icon>}
                      onClick={() => {
                        handleGuardarNuevosDatos2();
                      }}
                      size="small"
                      color="primary"
                      disabled={btnGuardar2}
                    >
                      Guardar
                    </Button>
                  </MDBox>
                ))}
              <MDBox>
                <MDTypography
                  component="a"
                  href="#"
                  variant="caption"
                  color="primary"
                  fontWeight="medium"
                  paddingRight={1}
                >
                  Antecedentes Heredofamiliares
                </MDTypography>
              </MDBox>
              <AntecedentesHeredoFamiliares
                ref={refAntecedentesHeredo}
                Back={() => {}}
                Next={(data) => {}}
                desactivar={desactivar2}
                IntentoSolicitud={(info) => {}}
                mostraOpcionesTab={false}
                vista={"visualizar"}
                props={detalleSolicitud}
              />
              <Divider />
              <MDBox>
                <MDTypography
                  component="a"
                  href="#"
                  variant="caption"
                  color="primary"
                  fontWeight="medium"
                  paddingRight={1}
                >
                  Antecedentes Personales no Patologicos del Menor
                </MDTypography>
              </MDBox>
              <AntecedentesPatologicos
                ref={refAntecedentesPersonales}
                Back={() => {}}
                Next={(data) => {}}
                desactivar={desactivar2}
                IntentoSolicitud={(info) => {}}
                vista={"visualizar"}
                props={detalleSolicitud}
              />
              <Divider />
              <MDBox>
                <MDTypography
                  component="a"
                  href="#"
                  variant="caption"
                  color="primary"
                  fontWeight="medium"
                  paddingRight={1}
                >
                  Antecedentes Prenatales
                </MDTypography>
              </MDBox>
              <AntecedentesPrenatales
                ref={refAntecedentesPrenatales}
                Back={() => {}}
                Next={(data) => {}}
                desactivar={desactivar2}
                IntentoSolicitud={(info) => {}}
                vista={"visualizar"}
                props={detalleSolicitud}
              />
              <AntecedentesPerinatales
                ref={refAntecedentesPerinatales}
                Back={() => {}}
                Next={(data) => {}}
                desactivar={desactivar2}
                IntentoSolicitud={(info) => {}}
                vista={"visualizar"}
                props={detalleSolicitud}
              />
              <Divider />
              <MDBox>
                <MDTypography
                  component="a"
                  href="#"
                  variant="caption"
                  color="primary"
                  fontWeight="medium"
                  paddingRight={1}
                >
                  Evaluación Auditiva
                </MDTypography>
              </MDBox>
              <EvaluacionAuditiva
                ref={refEvalaucionAuditiva}
                Back={() => {}}
                Next={(data) => {}}
                desactivar={desactivar2}
                IntentoSolicitud={(info) => {}}
                vista={"visualizar"}
                props={detalleSolicitud}
              />
              <Divider />
              <MDBox>
                <MDTypography
                  component="a"
                  href="#"
                  variant="caption"
                  color="primary"
                  fontWeight="medium"
                  paddingRight={1}
                >
                  Desarrollo Motor
                </MDTypography>
              </MDBox>
              <DesarrolloMotor
                ref={refDesarrolloMotor}
                Back={() => {}}
                Next={(data) => {}}
                desactivar={desactivar2}
                IntentoSolicitud={(info) => {}}
                vista={"visualizar"}
                props={detalleSolicitud}
              />
              <Divider />
              <MDBox>
                <MDTypography
                  component="a"
                  href="#"
                  variant="caption"
                  color="primary"
                  fontWeight="medium"
                  paddingRight={1}
                >
                  Información Adicional
                </MDTypography>
              </MDBox>
              <DatosAdicionales1
                ref={refInfoAdicional}
                Back={() => {}}
                Next={(data) => {}}
                desactivar={desactivar2}
                IntentoSolicitud={(info) => {}}
                vista={"visualizar"}
                props={detalleSolicitud}
              />
            </>
          ),
        },
    docadministrativa.length === 0
      ? null
      : {
          label: "Doc. Administrativa",
          icon: <ArchiveIcon />,
          panel: (
            <DocumentacionAdministrativaEdit
              documentacionAdministrativa={documentacionAdministrativa}
              estatusdocumentacion={{
                docAdministrativaValidada: detalleSolicitud?.docAdministrativaValidada,
                docAdministrativaValidadaPor: detalleSolicitud?.docAdministrativaValidadaPorName,
              }}
              idSolicitud={detalleSolicitud?.idSolicitud}
              ocultarCampos={false}
              observacionesDocAdmva={detalleSolicitud?.observacionesDocAdmva}
              esExpediente={detalleSolicitud?.esExpediente == 1}
            />
          ),
        },
    docclinica.length === 0
      ? null
      : {
          label: "Doc. Clinica",
          icon: <MedicalInformationIcon />,
          panel: (
            <DocumentacionClinicaEdit
              documentacionClinica={documentacionClinica}
              estatusdocumentacion={{
                docClinicaValidada: detalleSolicitud?.docClinicaValidada,
                docClinicaValidadaPor: detalleSolicitud?.docClinicaValidadaPorName,
              }}
              idSolicitud={detalleSolicitud?.idSolicitud}
              observacionesAudiologo={detalleSolicitud?.observacionesAudiologo}
              observacionesOtorrino={detalleSolicitud?.observacionesOtorrino}
              esExpediente={detalleSolicitud?.esExpediente == 1}
            >
              <DocumentacionAdministrativaEdit
                documentacionAdministrativa={docClinicaMostrar}
                estatusdocumentacion={{}}
                idSolicitud={detalleSolicitud?.idSolicitud}
                ocultarCampos={true}
                esExpediente={detalleSolicitud?.esExpediente == 1}
              />
            </DocumentacionClinicaEdit>
          ),
        },
    estuciosocioeconomico.length === 0
      ? null
      : {
          label: "Estudio Socioeconomico",
          icon: <ConnectWithoutContactIcon />,
          panel: (
            <EstudiosSocioeconomicoEdit
              documentacionse={estudiosSE}
              estatusdocumentacion={{
                estudiosSEValidados: detalleSolicitud?.estudiosSEValidados,
                estudiosSEValidadosPor: detalleSolicitud?.estudiosSEValidadosPorName,
              }}
              idSolicitud={detalleSolicitud?.idSolicitud}
              esExpediente={detalleSolicitud?.esExpediente == 1}
            />
          ),
        },
    citas.length === 0
      ? null
      : {
          label: "Gestion de Citas",
          icon: <EventIcon />,
          panel: (
            <Citas
              idDetalleSolicitud={detalleSolicitud?.idSolicitud}
              pacienteNombre={`${detalleSolicitud?.nombreCandidato} ${detalleSolicitud?.aPaternoCandidato} ${detalleSolicitud?.aMaternoCandidato}`}
              esExpediente={detalleSolicitud?.esExpediente == 1}
            />
          ),
        },
    reuniones.length === 0
      ? null
      : {
          label: "Reunión Nacional",
          icon: <GroupsIcon />,
          panel: (
            <DocumentosReunionNacional
              documentacionse={docsReunionNacional}
              estatusdocumentacion={{
                docsNacionalValidados: detalleSolicitud?.docsNacionalValidados,
                docsNacionalValidadosPor: detalleSolicitud?.docsNacionalValidadosPorName,
              }}
              idSolicitud={detalleSolicitud?.idSolicitud}
              esExpediente={detalleSolicitud?.esExpediente == 1}
            />
          ),
        },
    reuniones.length === 0
      ? null
      : {
          label: "Reunión Boston",
          icon: <ApartmentIcon />,
          panel: (
            <DocumentosReunionBoston
              documentacionse={docsReunionBoston}
              estatusdocumentacion={{
                docsBostonValidados: detalleSolicitud?.docsBostonValidados,
                docsBostonValidadosPor: detalleSolicitud?.docsBostonValidadosPorName,
              }}
              idSolicitud={detalleSolicitud?.idSolicitud}
              convertirExpediente={
                detalleSolicitud?.docsNacionalValidados == 1 &&
                detalleSolicitud?.docsBostonValidados == 1 &&
                detalleSolicitud?.esExpediente == 0
              }
              esExpediente={detalleSolicitud?.esExpediente == 1}
            />
          ),
        },
    galeria.length === 0
      ? null
      : {
          label: "Galería",
          icon: <PhotoCameraBackIcon />,
          panel: (
            <Galeria
              idSolicitud={detalleSolicitud?.idSolicitud}
              esExpediente={detalleSolicitud?.esExpediente == 1}
            />
          ),
        },
  ].filter(Boolean);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Header
        infomenor={{
          id: state?.id,
          idSolicitud: state?.idMostrar,
          nombre: `${detalleSolicitud?.nombreCandidato} ${detalleSolicitud?.aPaternoCandidato} ${detalleSolicitud?.aMaternoCandidato}`,
          fecha: moment(detalleSolicitud?.fechaNacimiento).format("DD/MM/YYYY"),
          title: detalleSolicitud?.esExpediente == 0 ? "Solictud " : "Expediente ",
          fechaAplicacion: moment(detalleSolicitud?.fechaAplicacion).format("DD/MM/YYYY"),
        }}
        esSolicitud={state?.esSolicitud}
      >
        {isloadingdetalleSolicitud ? (
          <Loading title={"Procesando por favor espere..."} />
        ) : (
          <MDBox>
            <AppBar position="static">
              <Tabs orientation="horizontal" value={tabValue} onChange={handleSetTabValue}>
                {seccionesVisibles.map((sec, i) => (
                  <Tab key={i} label={sec.label} icon={sec.icon} sx={{ fontSize: "0.8rem" }} />
                ))}
              </Tabs>
            </AppBar>

            <Paper
              sx={{
                height: "43rem",
                overflowY: "auto",
                padding: "1rem",
                background: "transparent",
              }}
            >
              {seccionesVisibles.length === 0 ? (
                <MDBox textAlign="center">
                  <MDTypography variant="h6" color="white">
                    No cuenta con permisos de visualización
                  </MDTypography>
                </MDBox>
              ) : (
                seccionesVisibles.map((sec, i) => (
                  <TabPanel key={i} value={tabValue} index={i} dir={"x"}>
                    {sec.panel}
                  </TabPanel>
                ))
              )}
            </Paper>
          </MDBox>
        )}
      </Header>
      <Toaster
        toastOptions={{ style: { backgroundColor: "#5873B8", fontSize: 12, color: "white" } }}
      />
      <Footer />
    </DashboardLayout>
  );
}
export function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <MDBox sx={{ p: 3 }}>
          <MDTypography>{children}</MDTypography>
        </MDBox>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default DetallesSolicitud;
